import { render, staticRenderFns } from "./PreturiManopera.vue?vue&type=template&id=38c08338&scoped=true"
import script from "./PreturiManopera.vue?vue&type=script&lang=js"
export * from "./PreturiManopera.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "38c08338",
  null
  
)

export default component.exports